export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const UNSET_NOTIFICATION = 'UNSET_NOTIFICATION';
